import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { SimilInputSpan } from '../../../../../../ui/form/SimilInputSpan.tsx';
import { $SpaceCompact } from '../../../../../../ui/form/SpaceCompact.ts';
import { type IAsyncService } from '../../../../../expressions/repository/async/context/IAsyncService.ts';

export interface IServiceInputSelectProps {
  label: string;
  service: IAsyncService;
  name: string;
}

export function ServiceInputSelect(props: IServiceInputSelectProps) {
  const { label, service, name } = props;
  return (
    <$SpaceCompact block size="large">
      <SimilInputSpan>{label}</SimilInputSpan>
      <SelectInput
        allowClear
        showSearch
        style={{ width: '100%' }}
        name={name}
        options={
          service.inputs.map(o => ({
            label: o.name,
            value: o.name,
          })) ?? []
        }
        onChange={(value, option, onChange) => {
          onChange(value ?? null);
        }}
      />
    </$SpaceCompact>
  );
}
